/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, prefer-const, @typescript-eslint/no-inferrable-types */
import { parseISO } from 'date-fns';
import { isValid } from 'date-fns/esm';
import { FieldAttributes, useField, useFormikContext } from 'formik';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import { Button, Col, Form, FormControl, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import {
  FaChevronLeft,
  FaChevronRight,
  FaRegCalendarAlt,
} from 'react-icons/fa';

import { sqlDateTimeUtcStr } from '../../utils';
import { FieldLabel, FlexRow } from '../index';
import './field-dateranger.css';

//@ts-ignore
//
//-------------------- Custom Input -------------------------------------------
//
const InputWithButton = forwardRef((props, ref) => {
  const { required, touched, error, disabled, onClick, ...rest } = props as any;
  return (
    <InputGroup style={{ flex: 1 }}>
      <FormControl
        style={required && !disabled ? { backgroundColor: 'lightYellow' } : {}}
        {...rest}
        onClick={() => false}
        isInvalid={touched && !!error}
        disabled={disabled}
        // onFocus={() => false}
        // onChange={() => false }
      />
      <Button
        variant="primary"
        className="react-datepicker-ignore-onclickoutside btn-dark"
        style={{
          paddingTop: '0.1rem',
          paddingBottom: '0.1rem',
          paddingLeft: '0.2rem',
          paddingRight: '0.2rem',
          borderTopRightRadius: '0.3rem',
          borderBottomRightRadius: '0.3rem',
          backgroundColor: '#aeaeae',
          borderColor: '#ced4da',
        }}
        // @ts-ignore
        disabled={disabled}
        // @ts-ignore
        onClick={onClick}
      >
        <FaRegCalendarAlt
          size="1rem"
          style={{ marginBottom: '11px', verticalAlign: 'top' }}
        />
      </Button>
      {/*
 // @ts-ignore   */}
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </InputGroup>
  );
});

//---------------------------------------------------------------------------
type Props = {
  readonly as?: React.ElementType<any>;
  readonly label: string;
  readonly label2: string;
  readonly placeholder?: string;
  readonly dateFormat?: string;
  readonly disabled?: boolean;
  readonly required?: boolean;
  readonly maxDate?: Date;
  readonly minDate?: Date;
} & FieldAttributes<any>;

const FieldDateRanger = ({
  as = 'div',
  name,
  name2,
  label,
  label2,
  placeholder = '',
  dateFormat = 'dd/MM/yyyy',
  disabled = false,
  required = false,
  maxDate,
  minDate,
}: Props) => {
  const { t } = useTranslation();
  //
  //-------------------- Body -----------------------------------------------
  //
  const [{ value }, { error, initialValue, touched }] = useField<Date>(name);
  const [{ value: value2 }, { error: error2, touched: touched2 }] =
    useField<Date>(name2);
  const { setFieldValue, setFieldTouched } = useFormikContext<any>();
  const { setFieldValue: setFieldValue2, setFieldTouched: setFieldTouched2 } =
    useFormikContext<any>();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  // const [actualValue, setActualValue] = useState<Date>(typeof value === 'string' ? parseISO(value) : value);

  // useEffect(() => {
  //   console.log('Value changed:', value, value !== actualValue);
  //   if (value !== actualValue) {
  //     setActualValue(typeof value === 'string' ? parseISO(value) : value);
  //   }
  // }, [value]); // value  only

  //
  //-------------------- Handlers -------------------------------------------
  //
  const setFieldValueAndTouched = async (
    _value: Date | null,
    touched: boolean
  ) => {
    if (isValid(_value)) {
      await setFieldValue(name, _value, true); //field,value,shouldValidate
    } else {
      await setFieldValue(name, null, true); //field,value,shouldValidate
    }
    await setFieldTouched(name, touched, false); //field,touched,shouldValidate
  };

  const handleChange = (date: Date) => {
    // setActualValue(date);
    setFieldValueAndTouched(date, true);
  };

  const handleBlur = () => {
    setFieldValueAndTouched(value, true);
  };
  const changed = value !== initialValue;

  const setFieldValueAndTouched2 = async (
    _value2: Date | null,
    touched2: boolean
  ) => {
    if (isValid(_value2)) {
      await setFieldValue2(name2, _value2, true); //field,value,shouldValidate
    } else {
      await setFieldValue2(name2, null, true); //field,value,shouldValidate
    }
    await setFieldTouched2(name2, touched2, false); //field,touched,shouldValidate
  };

  const handleChange2 = (date: Date) => {
    // setActualValue(date);
    setFieldValueAndTouched2(date, true);
  };

  const handleBlur2 = () => {
    setFieldValueAndTouched2(value2, true);
  };

  const handlePeriodClick = (direction: 'next' | 'previous') => {
    // Μετάβαση σε Επόμενο ή Προηγούμενο Χρονικό Διάστημα
    let fromDate: Date = value;
    let tillDate: Date = value2;
    if (fromDate === null && tillDate === null) {
      // Αρχικοποίηση στο σήμερα
      fromDate = moment().startOf('day').toDate();
      tillDate = moment().endOf('day').toDate();
    } else if (fromDate !== null && tillDate !== null) {
      // keep date only & disgard time
      fromDate = new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate()
      );
      tillDate = new Date(
        value2.getFullYear(),
        value2.getMonth(),
        value2.getDate()
      );

      // Περίοδος = 1 ημέρα
      if (tillDate.valueOf() === fromDate.valueOf()) {
        // Μετακινήσου 1 ημέρα
        const days2add = direction === 'next' ? 1 : -1;
        fromDate.setDate(fromDate.getDate() + days2add);
        tillDate = fromDate;
      } else {
        // Περίοδος = x Μήνες
        const monthsDiff = moment(tillDate)
          .add(1, 'days')
          .diff(moment(fromDate), 'months', true);
        if (Number.isInteger(monthsDiff)) {
          if (direction === 'next') {
            fromDate = moment(tillDate).add(1, 'days').toDate();
            tillDate = moment(fromDate)
              .add(monthsDiff, 'months')
              .add(-1, 'days')
              .toDate();
          } else if (direction === 'previous') {
            tillDate = moment(fromDate).add(-1, 'days').toDate();
            fromDate = moment(fromDate).add(-monthsDiff, 'months').toDate();
          }
        }
        // Περίοδος = x Εβδομάδες
        else {
          // diff in days
          const msDiff = tillDate.valueOf() - fromDate.valueOf();

          if (direction === 'next') {
            tillDate.setDate(tillDate.getDate() + 1);
            fromDate = tillDate;
            tillDate = new Date(tillDate.valueOf() + msDiff);
          } else if (direction === 'previous') {
            fromDate.setDate(fromDate.getDate() - 1);
            tillDate = fromDate;
            fromDate = new Date(fromDate.valueOf() - msDiff);
          }
        }
      }
    }
    setFieldValue(name, fromDate, false);
    setFieldValue(name2, tillDate, false);
  };

  // useWhyDidYouUpdate('[FieldDatePicker]', { name, value, error, initialValue, touched, actualValue });
  //
  //-------------------- Render -------------------------------------------
  //
  return (
    <Form.Group as={as} className="mb-2" controlId={name}>
      <FlexRow>
        <Col style={{ paddingLeft: '0px' }}>
          <FieldLabel text={label} changed={changed} required={required} />

          <DatePicker
            todayButton={t('Today')}
            autoComplete="off"
            preventOpenOnFocus
            onCalendarOpen={() => setOpen(true)}
            onCalendarClose={() => setOpen(false)}
            placeholderText={placeholder}
            dateFormat={dateFormat}
            selected={typeof value === 'string' ? parseISO(value) : value}
            //@ts-ignore
            customInput={
              //@ts-ignore
              <InputWithButton name={name} touched={touched} error={error} />
            }
            onChange={handleChange}
            onBlur={handleBlur}
            isClearable
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            disabled={disabled || open2}
            required={required}
            minDate={minDate}
            maxDate={maxDate}
            selectsStart
            startDate={typeof value === 'string' ? parseISO(value) : value}
            endDate={typeof value2 === 'string' ? parseISO(value2) : value2}
            // required={props.required}
          />
        </Col>
        <Col style={{ paddingRight: '0px' }}>
          <FieldLabel
            text={label2 ? label2 : 'Έως'}
            changed={changed}
            required={required}
          />
          <DatePicker
            todayButton="Σήμερα"
            autoComplete="off"
            preventOpenOnFocus
            onCalendarOpen={() => setOpen2(true)}
            onCalendarClose={() => setOpen2(false)}
            placeholderText={placeholder}
            dateFormat={dateFormat}
            selected={typeof value2 === 'string' ? parseISO(value2) : value2}
            //@ts-ignore
            customInput={
              //@ts-ignore
              <InputWithButton name={name2} touched={touched2} error={error2} />
            }
            popperModifiers={{
              offset: {
                enabled: true,
                offset: '5px, 10px',
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                boundariesElement: 'viewport',
              },
            }}
            onChange={handleChange2}
            onBlur={handleBlur2}
            isClearable
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            disabled={disabled || open}
            required={required}
            minDate={typeof value === 'string' ? parseISO(value) : value}
            maxDate={maxDate}
            endDate={typeof value2 === 'string' ? parseISO(value2) : value2}
            // required={props.required}
          />
        </Col>
        <Col xs="auto" style={{ paddingRight: '0px', paddingTop: '0.8rem' }}>
          {/* priorPeriod */}
          <Button
            type="button"
            className="btn btn-secondary"
            style={{
              marginRight: '3px',
              backgroundColor: '#aeaeae',
              borderColor: '#aeaeae',
              height: '1.4rem',
              width: '1.4rem',
              padding: 0,
              lineHeight: 1,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={(e) => {
              handlePeriodClick('previous');
            }}
          >
            <FaChevronLeft
              size="0.8rem"
              style={{ display: 'block' }}
            />
          </Button>
          {/* nextPeriod */}
          <Button
            type="button"
            className="btn btn-secondary"
            style={{
              marginRight: '0px',
              backgroundColor: '#aeaeae',
              borderColor: '#aeaeae',
              height: '1.4rem',
              width: '1.4rem',
              padding: 0,
              lineHeight: 1,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={(e) => {
              handlePeriodClick('next');
            }}
          >
            <FaChevronRight
              size="0.8rem"
              style={{ display: 'block' }}
            />
          </Button>
        </Col>
      </FlexRow>
    </Form.Group>
  );
};

function buildWhereForDates(
  startDate: string,
  endDate: string,
  fieldName: string
) {
  /*eslint-disable-off*/
  let where: any = {};

  // remove time from start-date
  const newStartDate = new Date(startDate);
  newStartDate.setHours(0, 0, 0, 0); // remove time

  // add 24 hours to end-date
  const newEndDate = new Date(endDate);
  newEndDate.setHours(0, 0, 0, 0); // remove time
  newEndDate.setDate(newEndDate.getDate() + 1); // add 24 hrs

  if (startDate && endDate) {
    where[fieldName] = { $and: [{ $gte: newStartDate }, { $lt: newEndDate }] };
  } else if (startDate && (!endDate || endDate === null)) {
    where[fieldName] = { $gte: newStartDate };
  } else if ((!startDate || startDate === null) && endDate) {
    where[fieldName] = { $lt: newEndDate };
  }

  return where;
}

function buildWhereForIncludePeriod(
  startDate: string,
  endDate: string,
  fieldNameStart: string,
  fieldNameEnd: string
) {
  /*eslint-disable-off*/
  let where: any = {};

  // remove time from start-date
  const newStartDate = new Date(startDate);
  newStartDate.setHours(0, 0, 0, 0); // remove time

  // add 24 hours to end-date
  const newEndDate = new Date(endDate);
  newEndDate.setHours(0, 0, 0, 0); // remove time
  newEndDate.setDate(newEndDate.getDate() + 1); // add 24 hrs

  if (startDate) where[fieldNameEnd] = { $gte: newStartDate };
  if (endDate) where[fieldNameStart] = { $lte: newEndDate };

  return where;
}

function buildSqlWhereForDates(
  startDate: string,
  endDate: string,
  fieldName: string
) {
  /*eslint-disable-off*/
  let where: string = '';

  // remove time from start-date
  const newStartDate = new Date(startDate);
  newStartDate.setHours(0, 0, 0, 0); // remove time

  // add 24 hours to end-date
  const newEndDate = new Date(endDate);
  newEndDate.setHours(0, 0, 0, 0); // remove time
  newEndDate.setDate(newEndDate.getDate() + 1); // add 24 hrs

  const sqlStart = `'${sqlDateTimeUtcStr(newStartDate)}'`;
  const sqlEnd = `'${sqlDateTimeUtcStr(newEndDate)}'`;

  if (startDate && endDate) {
    where = `( (${fieldName} >= ${sqlStart}) AND (${fieldName} < ${sqlEnd}) )`;
  } else if (startDate && (!endDate || endDate === null)) {
    where = `(${fieldName} >= ${sqlStart})`;
  } else if ((!startDate || startDate === null) && endDate) {
    where = `(${fieldName} < ${sqlEnd})`;
  }

  return where;
}
export {
  FieldDateRanger,
  buildWhereForDates,
  buildWhereForIncludePeriod,
  buildSqlWhereForDates,
};
